import { GridRenderEditCellParams, GridRowModes } from '@mui/x-data-grid-pro';
import { ColorPicker } from '../ColorPicker';

interface IGridColConditionProps {
  params: GridRenderEditCellParams;
}

export const GridColColor = ({ params }: IGridColConditionProps) => {
  const { api, id, field, value } = params;

  const isEditMode = api.getRowMode(id) === GridRowModes.Edit;

  const handleChange = (value: string) => {
    api.setEditCellValue({ id, field, value });
  };

  return <ColorPicker color={value} edit={isEditMode} onChange={handleChange} />;
};
